function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component, Fragment } from 'react';
import numeral from 'numeral';
import moment from 'moment';
import DefaultModal from 'Modals/DefaultModal';
import CancelIcon from '@material-ui/icons/Cancel';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import DeleteIcon from '@material-ui/icons/Delete';
import Button from '@material-ui/core/Button';
import LinkedModelsInfos from 'Components/LinkedModelsInfos';
import Link from 'Pure/Link';
import Loader from 'Pure/Loader';
import { front_urls, URL } from 'Shared/Routes';
import { isTrue } from 'Shared/utilities';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import handleChange from 'Components/Forms/Functions/handleChange';
numeral.locale('en');
moment.locale('fr');
export default class UserRow extends Component {
  state = {
    loading: false,
    openDeleteUserModal: false,
    status_messages: {},
    needs_confirmation: false
  };
  delete_ref = React.createRef();
  deleteUser = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/user/delete', {
      id: state.delete_modal_user,
      confirmation: state.needs_confirmation === true
    }).then(function (xhr, response) {
      component.setState({
        loading: false
      });
      component.delete_ref?.current?.click();
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        }),
        linked_models: response.linked_models,
        needs_confirmation: response.linked_models ? true : false
      });
    });
  };
  openDeleteUserModal = ({
    user_id,
    e
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    e.persist();
    component.setState({
      openDeleteUserModal: true,
      delete_modal_user: user_id,
      delete_modal_trigger: e.target
    });
  };
  closeDeleteModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      openDeleteUserModal: false,
      delete_modal_user: undefined,
      delete_modal_trigger: undefined
    });
    props.requestUpdate();
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const {
      data,
      blank = false,
      fields
    } = props;
    const blank_props = blank === true ? {
      target: '_blank',
      rel: 'noopener noreferrer'
    } : {};
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['white', 'bg-carbon']
    }) : undefined;
    const link = /*#__PURE__*/React.createElement(Link, _extends({
      className: "u-link-only"
    }, blank_props, {
      href: URL('AdminUsersDashboard', front_urls) + '/' + data.id
    }), "Fiche de l'utisateur");
    let output = /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell User-login"
    }, data.login, link), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell User-login"
    }, data.lastname, link), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell User-login"
    }, data.firstname, link), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell User-login"
    }, data.super_admin ? "Super admin" : data.roles[0], link), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell"
    }, isTrue(data.can_export_data) ? "OUI" : "NON", link), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell User-actions"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "text",
      color: "primary",
      className: "c-dashboard__cell-info ",
      title: "Supprimer le compte",
      onClick: e => component.openDeleteUserModal({
        user_id: data.id,
        e: e
      })
    }, /*#__PURE__*/React.createElement(DeleteIcon, {
      color: "primary"
    }))), /*#__PURE__*/React.createElement(DefaultModal, {
      open: state.openDeleteUserModal,
      title: "Suppression d'un utilisateur",
      trigger_src: state.delete_modal_trigger,
      "close-ref": component.delete_ref,
      "hide-controls": true,
      bemit: ['default', 'medium'],
      onClose: component.closeDeleteModal
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-message c-message--blue"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-message__content"
    }, "Supprimer cet utilisateur\xA0?")), getFormStatus(state), /*#__PURE__*/React.createElement(LinkedModelsInfos, {
      models: state.linked_models
    }), /*#__PURE__*/React.createElement("div", {
      className: "c-modal__controls"
    }, /*#__PURE__*/React.createElement(Button, {
      color: "primary",
      className: "c-flat-btn c-flat-btn--red u-margin-right-15",
      onClick: component.deleteUser
    }, state.needs_confirmation ? 'Oui, supprimer définitivement' : 'Supprimer', loader), /*#__PURE__*/React.createElement(Button, {
      color: "primary",
      className: "c-flat-btn",
      onClick: e => component.delete_ref?.current?.click()
    }, "Annuler"))));
    return output;
  }
}
